import React from "react"
import { ImageZoomable } from "./image-zoomable"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { ArticleContentComponentContainer } from "../utils"

export const Image = ({ image }) => {
  const image_data = getImage(image)
  const {
    fields: {
      caption,
      focus_point: { x, y },
    },
  } = image

  if (image_data?.width >= image_data?.height) {
    return (
      <ArticleContentComponentContainer>
        <figure className="is-marginless">
          <GatsbyImage
            image={image_data}
            alt={caption}
            title={caption}
            objectPosition={
              !!x
                ? `${Math.round(100 * x)}% ${Math.round(100 * y)}%`
                : undefined
            }
          />
          <figcaption>{caption}</figcaption>
        </figure>
      </ArticleContentComponentContainer>
    )
  } else {
    return (
      <ImageZoomable
        {...{ image, zoom_image: image, automatically_detected: true }}
      />
    )
  }
}
